import Layout from "../components/Layout";
import { Reveal } from "../components/Reveal";
import { PageHeader } from "../components/bits";

const SECTIONS = [
  {
    h: "What we collect",
    p: "When you join the waitlist, request an ROI estimate, or subscribe to updates, we collect the details you submit — such as your name, email address, ZIP code, number of devices, and company. We do not collect payment information on this site.",
  },
  {
    h: "How we use it",
    p: "We use your information to contact you about ChargeRevo, reserve your founding-member spot, send the ROI estimate you requested, and share product updates. We do not sell your personal information.",
  },
  {
    h: "Email",
    p: "Transactional emails (waitlist confirmation, ROI estimate) are sent in response to your request. You can unsubscribe from marketing updates at any time using the link in any email or by contacting us.",
  },
  {
    h: "Data retention & your rights",
    p: "You may request access to, correction of, or deletion of your personal data at any time. When you ask us to delete your data, we remove it from our active systems. Email us to make a request.",
  },
  {
    h: "Cookies & analytics",
    p: "We use privacy-respecting analytics to understand how the site is used and to improve it. These do not identify you personally.",
  },
  {
    h: "Contact",
    p: "Questions about this policy or your data? Email Requests@ChargeRevo.com and we'll respond promptly.",
  },
];

export default function Privacy() {
  return (
    <Layout>
      <PageHeader
        eyebrow="Privacy"
        title="Your data, handled honestly."
        subtitle="We hold ourselves to the same straight-talk standard on privacy as we do on physics. Here's exactly what we collect and why."
      />
      <section className="bg-white px-5 pb-28 pt-4 md:px-8">
        <div className="mx-auto max-w-3xl space-y-10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.05}>
              <div data-testid={`privacy-section-${i}`}>
                <h2 className="font-display text-2xl font-extrabold text-navy">{s.h}</h2>
                <p className="mt-3 text-lg leading-relaxed text-navy/70">{s.p}</p>
              </div>
            </Reveal>
          ))}
          <Reveal>
            <p className="border-t border-navy/10 pt-8 text-sm text-navy/50">
              This policy may be updated as ChargeRevo grows. Last updated June 2026. ChargeRevo. Patent pending.
            </p>
          </Reveal>
        </div>
      </section>
    </Layout>
  );
}
